import { Component, OnInit, Inject, ElementRef, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { CourseService } from '../../services/course.service';
import { NbDialogRef } from '@nebular/theme';
import { ItemsService } from '@scaffold/services/items.service';

@Component({
  selector: 'app-file-modal',
  templateUrl: './file-modal.component.html',
  styleUrls: ['./file-modal.component.scss']
})
export class FileModalComponent implements OnInit, AfterViewInit, OnDestroy {
  selected;
  data: any = {};
  constructor(public dialogRef: NbDialogRef<FileModalComponent>,
    private itemsService: ItemsService,
    private courseService: CourseService) { }
  @ViewChild('dialogContent') dialogConten: ElementRef;
  closing = false;
  ngOnInit() {
  }

  ngAfterViewInit() {
    console.log(this.data)
    //TEMP set z-index to above tinymce modal level for tinymce custom filebrowserj
    if (this.data.target_z) {
      this.dialogConten.nativeElement.closest(".cdk-overlay-container").className += " over-mce-dialog";
    }
  }
  ngOnDestroy() {
    //restore original z-index for material modal
    this.dialogConten.nativeElement.closest(".cdk-overlay-container").className = "cdk-overlay-container";
  }

  setFile(file) {
    console.log(file)
    this.selected = file;
    // this.selected = file;
    console.log('this.selected ', this.selected);
  }


  selectFile() {
    if (this.selected) {
      this.closing = true;
      if (this.selected.scope === 'institution') {
        console.log("Institution file");
        let data = {
          type: 'files',
          data: { included_file: this.selected.id, title: this.selected.data.title, size: this.selected.data.size, url: this.selected.data.url, type: this.selected.data.type }
      }
        let path = `courses/${this.courseService.id}/files?included_file=true`
        this.itemsService.createData(path, data).subscribe(d => {
          this.dialogRef.close(this.selected);
        });
      } else {
          this.dialogRef.close(this.selected);
      }
      
    }
  }
}
